export default __webpack_public_path__ + "static/media/icon_9.b27886e2.png";